import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigPreAuth } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const appExtendSessionReq = (req: any, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfigPreAuth(tokens),
    apiPath: APIEndPoints.appSessionExtend,
    method: 'POST',
    cache: false,
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { appExtendSessionReq }
